import Services from "../../services";

// API TERBARU PENERIMAAN BARANG

class ProgramApi {
  get(params) {
    return Services.get("/approval_program/list", { params });
  }

  getHistory(params) {
    return Services.get("/approval_program/history/list", {
      params,
    });
  }

  getSingle(params) {
    return Services.get("/approval_program/detail", { params });
  }

  approve(data) {
    return Services.post("/approval_program/approve", data);
  }
}

export default new ProgramApi();
